import api, { ApiResponse } from './api';

export interface EventFilter {
  id: number;
  competition_id: number;
  name: string;
  filter_type: 'exclude_keyword' | 'exclude_regex' | 'replace_exact' | 'replace_regex' | 'truncate';
  pattern: string;
  replacement: string;
  is_enabled: number;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface FilterTestResult {
  excluded: boolean;
  originalTitle: string;
  transformedTitle: string;
  appliedFilters: Array<{ id: number; name: string; filter_type: string }>;
}

export const eventFiltersService = {
  async list(competitionId: number): Promise<EventFilter[]> {
    const response = await api.get<ApiResponse<EventFilter[]>>('/event-filters', {
      params: { competition_id: competitionId },
    });
    return response.data.data;
  },

  async create(data: {
    competition_id: number;
    name: string;
    filter_type: EventFilter['filter_type'];
    pattern: string;
    replacement?: string;
  }): Promise<EventFilter> {
    const response = await api.post<ApiResponse<EventFilter>>('/event-filters', data);
    return response.data.data;
  },

  async update(id: number, data: {
    name?: string;
    filter_type?: EventFilter['filter_type'];
    pattern?: string;
    replacement?: string;
  }): Promise<EventFilter> {
    const response = await api.put<ApiResponse<EventFilter>>(`/event-filters/${id}`, data);
    return response.data.data;
  },

  async toggle(id: number): Promise<EventFilter> {
    const response = await api.put<ApiResponse<EventFilter>>(`/event-filters/${id}/toggle`);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/event-filters/${id}`);
  },

  async reorder(order: number[]): Promise<void> {
    await api.put('/event-filters/reorder', { order });
  },

  async test(competitionId: number, title: string): Promise<FilterTestResult> {
    const response = await api.post<ApiResponse<FilterTestResult>>('/event-filters/test', {
      competition_id: competitionId,
      title,
    });
    return response.data.data;
  },
};
